import { ActivatedRouteSnapshot } from '@angular/router';

export function resolveActivatedRouteParam(route: ActivatedRouteSnapshot, param: string): string | null {
  while (route) {
    if (route.params.hasOwnProperty(param)) {
      return route.params[param];
    }
    route = route.parent;
  }
  return null;
}
